import React, { useCallback } from "react"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { UniqueIdentifier } from "@dnd-kit/core"

type SortableItemProps<T> = {
    id: UniqueIdentifier
    item: T
    children: React.ReactNode
    onClick?: (item: T) => void
}

export const SortableItem = <T,>({ id, children, onClick, item }: SortableItemProps<T>) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: id })

    const style = {
        transform: CSS.Transform.toString(transform),
        transition: transition,
        opacity: isDragging ? 0.5 : 1,
        // Optimization: Use touch-action: none to prevent scrolling on mobile while dragging
        touchAction: "none" as React.CSSProperties["touchAction"],
    }

    const handleClick = useCallback(() => onClick && onClick(item), [item, onClick])

    return (
        <li ref={setNodeRef} style={style} {...attributes} {...listeners}>
            {onClick ? (
                <button type="button" onClick={handleClick} className={classes.buttonReset}>
                    {children}
                </button>
            ) : (
                children
            )}
        </li>
    )
}

const classes = {
    buttonReset: "block text-left w-full m-0 p-0 border-none bg-transparent cursor-pointer",
}
